import { WidgetInterface } from '@modules/widgets-module/interfaces/widget.interface'
import { PositionsWidgetComponent } from '@shared/components/trading/widgets/positions-widget/positions-widget.component'
import { OrdersWidgetComponent } from '@shared/components/trading/widgets/orders-widget/orders-widget.component'
import { WatchListWidgetComponent } from '@shared/components/trading/widgets/watch-list-widget/watch-list-widget.component'
import { CreateOrderWidgetComponent } from '@shared/components/trading/widgets/create-order-widget/create-order-widget.component'
import { TradingViewWidgetComponent } from '@shared/components/trading/widgets/trading-view-widget/trading-view-widget.component'
import { WidgetNameEnum } from '@modules/widgets-module/enums/widget-name.enum'
import { PortfolioWidgetActionsComponent } from '@shared/components/trading/widgets/portfolio-widget/portfolio-widget-actions/portfolio-widget-actions.component'
import { PortfolioSettingsInterface } from '@shared/components/trading/portfolio/core/interfaces/portfolio-settings.interface'
import { PositionsWidgetActionsComponent } from '@shared/components/trading/widgets/positions-widget/positions-widget-actions/positions-widget-actions.component'
import { WatchListWidgetActionsComponent } from '@shared/components/trading/widgets/watch-list-widget/watch-list-widget-actions/watch-list-widget-actions.component'
import { OrdersWidgetActionsComponent } from '@shared/components/trading/widgets/orders-widget/orders-widget-actions/orders-widget-actions.component'
import { PositionColumnsConstant } from '@shared/components/trading/widgets/positions-widget/core/contants/position-columns.constant'
import { ColumnsOpenedOrdersConstant } from '@shared/components/trading/widgets/orders-widget/core/contants/stocks/columns-opened-orders.constant'
import { ColumnsCanceledOrdersConstant } from '@shared/components/trading/widgets/orders-widget/core/contants/stocks/columns-canceled-orders.constant'
import { ColumnsFilledOrdersConstant } from '@shared/components/trading/widgets/orders-widget/core/contants/stocks/columns-filled-orders.constant'
import { WatchListColumnsConstant } from '@shared/components/trading/widgets/watch-list-widget/core/contants/watch-list-columns.constant'
import { InfoWidgetComponent } from '@shared/components/trading/widgets/info-widget/info-widget.component'
import { OptionsBoardWidgetComponent } from '@shared/components/trading/widgets/options-board-widget/options-board-widget.component'
import { OptionsBoardWidgetActionsComponent } from '@shared/components/trading/widgets/options-board-widget/options-board-widget-actions/options-board-widget-actions.component'
import { OptionsBoardColumnsConstant } from '@shared/components/trading/widgets/options-board-widget/core/contants/options-board-columns.constant'
import { AssetClassEnum } from '@modules/positions-module/enums/asset-class.enum'
import { ColumnsOptionsCanceledOrdersConstant } from '@shared/components/trading/widgets/orders-widget/core/contants/options/columns-options-canceled-orders.constant'
import { ColumnsOptionsOpenedOrdersConstant } from '@shared/components/trading/widgets/orders-widget/core/contants/options/columns-options-opened-orders.constant'
import { ColumnsOptionsExecutedOrdersConstant } from '@shared/components/trading/widgets/orders-widget/core/contants/options/columns-options-executed-orders.constant'
import { ColumnsPostTradingAssignedConstant } from '@shared/components/trading/widgets/orders-widget/core/contants/post-trading/columns-post-trading-assigned.constant'
import { ColumnsPostTradingExpiredConstant } from '@shared/components/trading/widgets/orders-widget/core/contants/post-trading/columns-post-trading-expired.constant'
import { ColumnsPostTradingExercisesConstant } from '@shared/components/trading/widgets/orders-widget/core/contants/post-trading/columns-post-trading-exercises.constant'
import { PositionOptionsColumnsConstant } from '@shared/components/trading/widgets/positions-widget/core/contants/position-options-columns.constant'
import { PositionSettingsInterface } from '@shared/components/trading/widgets/positions-widget/core/interfaces/position-settings.interface'
import { WatchListSettingsInterface } from '@shared/components/trading/widgets/watch-list-widget/core/interfaces/watch-list-settings.interface'
import { OptionsBoardSettingsInterface } from '@shared/components/trading/widgets/options-board-widget/core/interfaces/options-board-settings.interface'
import { PortfolioBlocksEnum } from '@shared/components/trading/portfolio/core/enums/portfolio-blocks.enum'
import { OptionOrderTypeEnum } from '@modules/options-module/orders/enums/option-order-type.enum'
import { PostTradingEventTypeEnum } from '@modules/options-module/post-trading/enums/post-trading-event-type.enum'
import { OrderStateEnum } from '@modules/orders-module/enums/order-state.enum'
import { PortfolioWidgetComponent } from '@shared/components/trading/widgets/portfolio-widget/portfolio-widget.component'

export const SourceWidgets: WidgetInterface[] = [
	{
		componentName: WidgetNameEnum.portfolio,
		icon: {
			lightUrl: './images/widgets/portfolio-widget-light.svg',
			darkUrl: './images/widgets/portfolio-widget-dark.svg',
			alt: 'widget.portfolio',
		},
		title: 'widget.portfolio',
		component: PortfolioWidgetComponent,
		needTicker: false,
		gridsterItem: { cols: 4, rows: 13, x: 0, y: 0, minItemCols: 4, minItemRows: 6 },
		columnSettingsComponent: PortfolioWidgetActionsComponent,
		scrollHorizontal: false,
		scrollVertical: true,
		sizes: {
			width: 380,
			height: 435,
		},
		settings: {
			visible: [
				PortfolioBlocksEnum.PORTFOLIO_VALUE,
				PortfolioBlocksEnum.PROFITABILITY,
				PortfolioBlocksEnum.PORTFOLIO_VALUATION,
				PortfolioBlocksEnum.RISK_LEVEL,
			],
			expanded: [
				PortfolioBlocksEnum.PORTFOLIO_VALUE,
				PortfolioBlocksEnum.PROFITABILITY,
				PortfolioBlocksEnum.PORTFOLIO_VALUATION,
				PortfolioBlocksEnum.RISK_LEVEL,
			],
		} as PortfolioSettingsInterface,
	},
	{
		componentName: WidgetNameEnum.position,
		icon: {
			lightUrl: './images/widgets/positions-widget-light.svg',
			darkUrl: './images/widgets/positions-widget-dark.svg',
			alt: 'widget.positions',
		},
		title: 'widget.positions',
		component: PositionsWidgetComponent,
		needTicker: false,
		gridsterItem: { cols: 10, rows: 11, x: 0, y: 0, minItemCols: 4, minItemRows: 6 },
		columnSettingsComponent: PositionsWidgetActionsComponent,
		assetClass: AssetClassEnum.US_EQUITY,
		scrollHorizontal: false,
		scrollVertical: false,
		sizes: {
			width: 690,
			height: 770,
		},
		settings: {
			stocks: {
				activeSort: { prop: 'unrealized_plpc', type: 'desc' },
				columns: PositionColumnsConstant,
			},
			options: {
				activeSort: { prop: 'unrealized_plpc', type: 'desc' },
				columns: PositionOptionsColumnsConstant,
			},
		} as PositionSettingsInterface,
	},
	{
		componentName: WidgetNameEnum.watchlist,
		icon: {
			lightUrl: './images/widgets/watch-list-widget-light.svg',
			darkUrl: './images/widgets/watch-list-widget-dark.svg',
			alt: 'widget.watchList',
		},
		title: 'widget.watchList',
		component: WatchListWidgetComponent,
		needTicker: false,
		gridsterItem: { cols: 7, rows: 10, x: 0, y: 0, minItemCols: 4, minItemRows: 6 },
		columnSettingsComponent: WatchListWidgetActionsComponent,
		scrollHorizontal: false,
		scrollVertical: false,
		sizes: {
			width: 535,
			height: 635,
		},
		settings: {
			activeSort: { prop: 'percentage_change', type: 'desc' },
			columns: WatchListColumnsConstant,
		} as WatchListSettingsInterface,
	},
	{
		componentName: WidgetNameEnum.createOrder,
		icon: {
			lightUrl: './images/widgets/create-order-widget-light.svg',
			darkUrl: './images/widgets/create-order-widget-dark.svg',
			alt: 'widget.createOrder',
		},
		title: 'widget.createOrder',
		component: CreateOrderWidgetComponent,
		needTicker: true,
		gridsterItem: { cols: 5, rows: 18, x: 0, y: 0, minItemCols: 5, minItemRows: 6 },
		scrollHorizontal: false,
		scrollVertical: true,
		sizes: {
			width: 460,
			height: 670,
		},
		settings: {},
	},
	{
		componentName: WidgetNameEnum.orders,
		icon: {
			lightUrl: './images/widgets/orders-widget-light.svg',
			darkUrl: './images/widgets/orders-widget-dark.svg',
			alt: 'widget.orders',
		},
		title: 'widget.orders',
		component: OrdersWidgetComponent,
		needTicker: false,
		gridsterItem: { cols: 9, rows: 12, x: 0, y: 0, minItemCols: 4, minItemRows: 6 },
		columnSettingsComponent: OrdersWidgetActionsComponent,
		assetClass: AssetClassEnum.US_EQUITY,
		scrollHorizontal: false,
		scrollVertical: false,
		sizes: {
			width: 690,
			height: 805,
		},
		settings: {
			stocks: {
				activeState: OrderStateEnum.OPEN,
				open: {
					columns: ColumnsOpenedOrdersConstant,
				},
				canceled: {
					columns: ColumnsCanceledOrdersConstant,
				},
				filled: {
					columns: ColumnsFilledOrdersConstant,
				},
			},
			options: {
				activeType: OptionOrderTypeEnum.ORDERS,
				orders: {
					activeState: OrderStateEnum.OPEN,
					open: {
						columns: ColumnsOptionsOpenedOrdersConstant,
					},
					canceled: {
						columns: ColumnsOptionsCanceledOrdersConstant,
					},
					filled: {
						columns: ColumnsOptionsExecutedOrdersConstant,
					},
				},
				postTrading: {
					activeType: PostTradingEventTypeEnum.EXPIRED,
					expired: {
						columns: ColumnsPostTradingExpiredConstant,
					},
					exercises: {
						columns: ColumnsPostTradingExercisesConstant,
					},
					assigned: {
						columns: ColumnsPostTradingAssignedConstant,
					},
				},
			},
		},
	},
	{
		componentName: WidgetNameEnum.info,
		icon: {
			lightUrl: './images/widgets/info-widget-light.svg',
			darkUrl: './images/widgets/info-widget-dark.svg',
			alt: 'widget.info',
		},
		title: 'widget.info',
		component: InfoWidgetComponent,
		assetClass: AssetClassEnum.US_EQUITY,
		needTicker: true,
		gridsterItem: { cols: 5, rows: 16, x: 0, y: 0, minItemCols: 5, minItemRows: 6 },
		scrollHorizontal: false,
		scrollVertical: true,
		sizes: {
			width: 535,
			height: 770,
		},
		settings: {},
	},
	{
		componentName: WidgetNameEnum.tradingView,
		icon: {
			lightUrl: './images/widgets/chart-light.svg',
			darkUrl: './images/widgets/chart-dark.svg',
			alt: 'widget.chart',
		},
		title: 'widget.chart',
		component: TradingViewWidgetComponent,
		needTicker: true,
		gridsterItem: { cols: 9, rows: 14, x: 0, y: 0, minItemCols: 4, minItemRows: 6 },
		scrollHorizontal: false,
		scrollVertical: false,
		sizes: {
			width: 1075,
			height: 805,
		},
		settings: {},
	},
	{
		componentName: WidgetNameEnum.optionsBoard,
		icon: {
			lightUrl: './images/widgets/options-board-widget-light.svg',
			darkUrl: './images/widgets/options-board-widget-dark.svg',
			alt: 'widget.chart',
		},
		title: 'widget.optionsBoard',
		component: OptionsBoardWidgetComponent,
		needTicker: true,
		gridsterItem: { cols: 11, rows: 14, x: 0, y: 0, minItemCols: 4, minItemRows: 6 },
		columnSettingsComponent: OptionsBoardWidgetActionsComponent,
		scrollHorizontal: false,
		scrollVertical: false,
		sizes: {
			width: 842,
			height: 805,
		},
		settings: { columns: OptionsBoardColumnsConstant } as OptionsBoardSettingsInterface,
	},
]
